// The figures at the top of Reports (spec/13 §2, §15): the headline three of the range in view — revenue, sessions and
// occupancy — read from the same two reports the Overview tab below reads (one cache entry each), never a number asked
// for on their own. Revenue is for a role with `reports:financial`; the others without it show the sessions half.

import { useTranslation, useVenueFormatter } from '@clavian/i18n/react';
import { HeroStat } from '@clavian/ui-web';
import type { ReactNode } from 'react';

import { type ReportScope, useRevenueReport, useSessionsReport } from './queries';
import { moneyShort, percentOf } from './tab-kit';

export function OverviewHero({ scope, canFinancial }: { readonly scope: ReportScope; readonly canFinancial: boolean }): ReactNode {
  const { t } = useTranslation('console');
  const format = useVenueFormatter();
  const revenue = useRevenueReport(scope, canFinancial);
  const sessions = useSessionsReport(scope, true);
  const dash = t('reports.hero.unknown');
  const totals = revenue.data?.totals ?? null;
  const now = sessions.data?.totals;
  return (
    <>
      {canFinancial ? (
        <HeroStat
          label={t('reports.kpi.revenue')}
          value={totals === null || revenue.data === undefined ? dash : moneyShort(format, totals.revenue.amount, revenue.data.currency)}
        />
      ) : null}
      <HeroStat label={t('reports.kpi.sessions')} value={now?.sessions === null || now === undefined ? dash : format.number(now.sessions)} />
      <HeroStat label={t('reports.kpi.occupancy')} value={now?.occupancyBasisPoints === null || now === undefined ? dash : percentOf(format, now.occupancyBasisPoints, 1)} />
      <HeroStat label={t('reports.kpi.averageSession')} value={now?.averageSeconds === null || now === undefined ? dash : format.duration(now.averageSeconds)} />
    </>
  );
}
